import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import classNames from 'classnames'
import { useGlobalStore } from '@/hoxStore/globalStore'
import { GovernanceCommunityAccountData } from '@/api/addressFormula/interface'
import AddressHash from '@/components/AddressHash'
import MeToolTip from '@/components/MeToolTip'
import { queryExists } from '@/api/common'
import useMeNavigate from '@/hooks/useMeNavigate'

const CardInfo = ({
  data,
  title,
  description,
  showTooltip,
  tipDescription,
}: {
  data: GovernanceCommunityAccountData | { address: string }
  title: string
  description: string
  showTooltip?: boolean
  tipDescription?: string
}) => {
  const { t } = useTranslation()
  const navigate = useMeNavigate()
  const { curReponsive } = useGlobalStore()
  const goToAccountDetail = async () => {
    navigate(`/moduleAccount/${data.address}`)
    // try {
    //   const res = await queryExists(data.address)
    //   if (res?.existence_check?.[0].search_type === 'module_account') {
    //   } else {
    //     navigate(`/accountDetail/${data.address}`)
    //   }
    // } catch (error) {
    //   console.log(error)
    // }
  }

  return (
    <div className={styles.wrap}>
      <div className="area_a">
        <div className={classNames(styles.title, 'font_14')}>{t('explorer_104')}</div>
        <div
          className={classNames(
            styles.textStyleTwo,
            `${curReponsive?.size !== 'mobile' ? 'font_16' : 'font_14'}`,
          )}
        >
          {showTooltip ? (
            <MeToolTip title={title} tip={tipDescription || ''}></MeToolTip>
          ) : (
            <span>{title}</span>
          )}
        </div>
      </div>
      <div className="area_b">
        <div className={classNames(styles.title, 'font_14')}>{t('explorer_114')}</div>
        <div className={classNames(styles.textStyleOne, 'font_16')}>
          <AddressHash
            data={data?.address}
            handleJump={goToAccountDetail}
            copyIcon={'gray'}
          ></AddressHash>
        </div>
      </div>

      <div className="area_c">
        <div className={classNames(styles.title, 'font_14')}>{t('explorer_197')}</div>
        <div
          className={classNames(
            styles.textStyleTwo,
            `${curReponsive?.size !== 'mobile' ? 'font_16' : 'font_14'}`,
            curReponsive?.size !== 'mobile' && styles.flex_right,
          )}
        >
          <span>{description || '-'}</span>
        </div>
      </div>
    </div>
  )
}

export default CardInfo
